if (!customElements.get('nl-lifestyle-mobile')) {
  customElements.define('nl-lifestyle-mobile', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.failedVariants = new Set();
      this.details = this.querySelector('details');
      this.content = this.querySelector('.nl-lifestyle-mobile__content');
      this.source = Array.from(this.parentElement?.children || []).find(element =>
        element.matches('nl-lifestyle') && element.dataset.productId === this.dataset.productId
      );
      if (!this.details || !this.content || !this.source) {
        this.hidden = true;
        return;
      }
      this.media = window.matchMedia('(max-width: 767px)');
      this.variants = this.closest('product-page')?.querySelector('product-variants[data-main-product-variants]');
      this.variants?.addEventListener('VARIANT_CHANGE', event => {
        this.showVariant(event.target.currentVariant?.id);
      }, { signal: this.controller.signal });
      this.details.addEventListener('toggle', () => {
        if (this.details.open) this.showImage();
        else this.clearImage();
      }, { signal: this.controller.signal });
      this.media.addEventListener('change', () => {
        if (!this.media.matches) {
          this.details.open = false;
          this.clearImage();
        }
      }, { signal: this.controller.signal });
      this.showVariant(this.variants?.currentVariant?.id ?? this.dataset.currentVariant);
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.clearImage();
    }

    templateFor(id) {
      if (!id || this.failedVariants.has(String(id))) return null;
      return Array.from(this.source.querySelectorAll(':scope > template[data-lifestyle-for]')).find(template =>
        template.dataset.lifestyleFor === String(id) &&
        template.content.querySelector('.nl-lifestyle__figure[data-image-kind="scene"] img')
      );
    }

    showVariant(id) {
      this.currentId = id == null ? '' : String(id);
      this.hidden = !this.templateFor(this.currentId);
      if (this.hidden) this.details.open = false;
      if (this.details.open && !this.hidden) this.showImage();
      else this.clearImage();
    }

    clearImage() {
      this.imageController?.abort();
      this.content?.replaceChildren();
    }

    showImage() {
      const template = this.templateFor(this.currentId);
      if (!this.details.open || !this.media.matches || !template || this.hidden) {
        this.clearImage();
        return;
      }
      if (this.content.querySelector('figure')?.dataset.lifestyleVariant === this.currentId) return;
      const fragment = template.content.cloneNode(true);
      const image = fragment.querySelector('img');
      const sources = fragment.querySelectorAll('source');
      const srcset = sources[0]?.getAttribute('srcset');
      const fallback = srcset?.split(',')[0].trim().split(/\s+/)[0];
      if (!image || !fallback) {
        this.hidden = true;
        this.details.open = false;
        this.clearImage();
        return;
      }
      this.clearImage();
      this.imageController = new AbortController();
      const variantId = this.currentId;
      image.addEventListener('error', () => {
        this.failedVariants.add(variantId);
        if (this.currentId === variantId) {
          this.hidden = true;
          this.details.open = false;
          this.clearImage();
        }
      }, { once: true, signal: this.imageController.signal });
      sources.forEach(source => source.remove());
      image.srcset = srcset;
      image.sizes = '(max-width: 767px) calc(100vw - 56px), 620px';
      image.src = fallback;
      this.content.append(fragment);
    }
  });
}
